import { Component, inject, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { FileDataStore } from '../../../store/file-data.store';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-download-icon-renderer',
    imports: [
        MatIcon,
        MatTooltip
    ],
    templateUrl: './download-icon-renderer.component.html',
    styleUrl: './download-icon-renderer.component.scss'
})
export class DownloadIconRendererComponent implements ICellRendererAngularComp, OnDestroy {
  readonly fileDataStore = inject(FileDataStore);
  private params!: ICellRendererParams<any, any>;

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any>) {
    this.params = params;
    return true;
  }

  onClick() {
    const rowToken = this.params.data?.rowToken ?? this.params.data?.RowToken;
    if (typeof rowToken !== 'string' || rowToken.trim() === '') {
      return; // Invalid row token, do not attempt download. TODO: Consider adding user feedback for this case.
    }
    this.params.context.componentParent.onDownloadClicked(rowToken);
  }

  ngOnDestroy() {
    // Use later for unsubscribing if needed.
  }
}
